
export default {
	name: 'change-voice-tariff-result-4G',
	mixins: [],
	extends: {},
	components: {},
	props: ['changeDate'],
	data() {
		return {};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		init(){
			if(!this.changeDate){
				this.$router.push({name: 'change-voice-tariff-4G'});
			}
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/changeVoiceTariff4G/changeVoiceTariffResult4G.js